export default [
  {
    id: 'teams',
    href: '/app/settings/teams',
    title: 'Create unlimited teams',
    children:
      "Create as many teams and invite as many team members as you want—it's all included in your trial. Zapier for Companies scales with your business.",
    imageAlt: 'Team creation workflow',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/ef03e11bc1ce7d5fc2384c0095510626.png',
  },
  {
    id: 'domain',
    href: '/app/settings/company/domain',
    title: 'Manage domain insights and account capture',
    children:
      'Allow only users at verified domains to join your company account and make sure your entire company is using a single account.',
    imageAlt: 'Settings view for company domain',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/281bde5d2fbf7c73ff00015cc305bc89.png',
  },
  {
    id: 'app-restriction',
    href: '/app/settings/company/app-restriction',
    title: 'Manage access to apps',
    children:
      'Choose which apps can send data to Zapier and be used in Zaps by your team members.',
    imageAlt: 'Settings view for app permissions',
    imageSrc:
      'https://zapier-images.imgix.net/storage/photos/bd28a02904096f36a96bcddb58a3744c.png',
  },
];
